import * as _ from 'lodash';
import Contract from '../../../services/contracts'
import Sales from '../../../services/sales'
import Financial from '../../../services/financial';
import PaymentOptions from './payment-options.vue';
import successPage from '../adhesion/success.vue'
import * as Utils from '../../../utils.js'
import {EventBus} from '../../../event-bus'
import messageDialog from '../../../components/message-dialog.vue';
import { orderBy } from 'lodash';

export default {
  props: ['value', 'contractId','payment', 'planId', 'addressMailing', 'creditCardOptions', 'bankAccountOptions', 'bankBillOption', 'value', 'showNewPayment', 'salesType','totalComDesconto','taxIdNumber'],
  data() {
    return {
      metodosDePagamento: [],
      paymentMethodsAuthorized: {},
      statusPix: undefined,
      jaUtilizouBoletoAntes: undefined,
      bandSelecionada: undefined,
      arrayDebito: undefined,
      arrayCartao: undefined,
      boletoCadastrato: undefined,
      boleto: undefined,
      index: 1,
      contractPaymentMethodId: this.value,
      loading:undefined,
      typesAlowed: {},
      dateTime: undefined,
      paymentMethods: undefined,
      secureCodeCreditCard: undefined,
      paymentSelected: undefined,
      BC: undefined,
      contaCorrente: undefined,
      saldoCorrente: undefined,
      statusContrato: undefined,
      toggleRadio: true,
      error: undefined,
      pixUrl:undefined,
      code:undefined,
      vads_action_mode:"INTERACTIVE",
      vads_amount:"1",
      vads_ctx_mode:"TEST",
      vads_currency:"986",
      vads_url_return:"https://www.movemais.com",
      vads_page_action:"PAYMENT",
      vads_payment_cards:"PIX",
      vads_payment_config:"SINGLE",
      vads_site_id:"84983797",
      vads_trans_date:"20220519172700",
      vads_trans_id:"123456",
      vads_version:"V2",
      certificate:"8365335201419102",
      signature:undefined,
      pagar:undefined,
      boletoUrl:undefined,
      isMobile: true,
      cpm: {
        "type": "CC",
        "ownerName": undefined,
        "number": undefined,
        "expirationMonth": undefined,
        "expirationYear": undefined,
        "cvv": undefined,
        "brand": undefined,
        "paymentMethodId": undefined,
        "imagePath": undefined,
        "error": undefined,
        "paymentMethod": {
          "paymentMethodId": undefined
        },
      },
      android: false
    }
  },
  created() {
    let vm = this;
    this.isMobile = $(window).width() < 1140;
    $(window).resize(function () {
      vm.isMobile = $(window).width() < 1140;
    });

    if (navigator.userAgent.match(/Android/i)){

        this.android = true;
    }
  },

  watch: {
    cpm: {
      handler(val){
        this.getPayment();
        this.handleCC();
      },
      deep: true
    },
    contractPaymentMethodId(){
      this.getPayment();
    },
    secureCodeCreditCard(){
      this.getPayment();
    }
  },

  computed: {

    request() {
      let vm = this;
      let request = {
        "_interface": window.document.webview ? "MOBILE" : "WEBSITE",
        account: vm.account,
        addresses: {
          address: [
            vm.address
          ]
        },
        contract: vm.contract,
        listVehicle: {
          vehicle: vm.vehicles
        },
        value: undefined
      };
      return request;
    },
    typesAllowed(){
      return this.$store.getters.getPaymentsTypesByPlan(this.planId);
    },
    checkPromoSenff() {
      if (sessionStorage.getItem('promoCheck') == '#SENFF2020')
        return true;
    },
    thisYear() {
      return new Date().getFullYear();
    },
    mostrarPagamentoPorSaldo() {
      return this.salesType == 'ADHESIONVEHICLEADDITIONAL';
    },

    mostrarNovaFormaDePagamento() {
      return this.salesType == 'ADHESIONVEHICLEADDITIONAL' || this.salesType == 'ADHESION' || (this.salesType ==  'RECHARGE')  ;
    },

    hasValidActivePaymentMethod() {
      const hasValidBalance = this.mostrarPagamentoPorSaldo &&
        this.isPaymentMethodAuthorized('DC');

      const hasValidPix = this.statusPix &&
        this.isPaymentMethodAuthorized('PX');

      const hasValidCreditCard = this.isPaymentMethodAuthorized('CC') &&
        (this.arrayCartao == null || this.arrayCartao.length < 3) &&
        this.planId != 6;

        return hasValidBalance || hasValidPix || hasValidCreditCard;
    }

  },
  mounted(){
      if (this.taxIdNumber) {
        Financial.getPaymentMethodUnauthorized(this.taxIdNumber).then(authResponse => {
          const authMethods = authResponse.data.data.paymentMethods;

          this.paymentMethodsAuthorized = {};

          authMethods.forEach(method => {
            this.paymentMethodsAuthorized[method.shortName] = method.authorized === 1;
          });

          this.getMeiosDePagamento();
          this.loadPaymentMethods();
        }).catch(error => {
          console.error('Erro ao buscar autorizações:', error);
          this.getMeiosDePagamento();
          this.loadPaymentMethods();
        });
    } else {
      this.getMeiosDePagamento();
      this.loadPaymentMethods();
    }

    this.$store.dispatch('getPlans').then(resp => {
      this.typesAlowed = this.$store.getters.getPaymentsTypesByPlan(this.planId);
    });
    Sales.getDateTimeTransaction().then(time =>{
      this.dateTime = time;
    });
  },

  methods:{

    loadPaymentMethods() {
      if (this.contractId) {

        this.loading = Contract.getPaymentMethodPm(this.contractId).then(res => {
          this.paymentMethods = res;

          let filteredRes = res;
          if (this.taxIdNumber && Object.keys(this.paymentMethodsAuthorized).length > 0) {
            filteredRes = res.filter(item => {
              const shortName = item.paymentMethod.paymentShortName;
              if (shortName && this.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
                return this.paymentMethodsAuthorized[shortName];
              }
            });
          }

        this.arrayDebito = _.filter(filteredRes, function(o){
          return o.paymentMethod.paymentShortName == 'DC'
        });
        this.arrayCartao = _.filter(filteredRes, function(o){

          return o.paymentMethod.paymentShortName == 'CC' && ( o.validado == null || o.validado == 1);
        });

        this.BC = _.find(filteredRes, function(o){
          return o.paymentMethod.paymentShortName == 'BC';
        });

        this.contaCorrente = _.find(filteredRes, function(o){
          return o.paymentMethod.paymentShortName == 'CR';
        });

        this.pix = _.find(filteredRes, function(o){
          return o.paymentMethod.paymentShortName == 'PX';
        });

        if(this.contaCorrente){
          this.contractPaymentMethodId = this.contaCorrente.paymentMethod.paymentMethodId;
        }
      });

        Contract.getContractByContractId(this.contractId).then(res => {
          this.saldoCorrente = res.currentBalance.currentBalance;
          this.statusContrato = res.status.contractStatusId;
        });

        this.getPayment();
      }
    },

    async getMeiosDePagamento() {
      const meios = await Financial.getMeiosDePagamentoAdesao(this.planId);
      let Arr = meios.data.list;

      if (this.taxIdNumber && Object.keys(this.paymentMethodsAuthorized).length > 0) {
        Arr = Arr.filter(element => {
          const shortName = this.getShortNameByPaymentMethodId(element.paymentMethodId);
          if (shortName && this.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
            return this.paymentMethodsAuthorized[shortName];
          }
        });
      }

      Arr.forEach((element) => {
        if (element.paymentMethodId === 120) {
          const pixAuthorized = this.isPaymentMethodAuthorized('PX');
          if (pixAuthorized) {
            if (element.isAutomatic === 1) {
              if (this.salesType === 'RECHARGE') {
                this.statusPix = true;
              }
            } else {
              this.statusPix = true;
            }
          } else {
            this.statusPix = false;
          }
        }
      });

      this.metodosDePagamento = Arr;
    },



    showBandeira(band) {
      const paymentMapping = {
        'Visa': 6,
        'Mastercard': 7,
        'Elo': 10,
        'HiperCard': 11
      };
      const requiredPaymentMethodId = paymentMapping[band];

      if (!this.metodosDePagamento || !this.metodosDePagamento.length) return false;

      return this.metodosDePagamento.some(pm =>
        pm.paymentMethodId === requiredPaymentMethodId && pm.displaySite === 'Y'
      );
    },


    getPayment: async function getPayment(){
      let id;
      this.error = undefined;
      if (this.salesType == "RECHARGE" && this.contractPaymentMethodId == 109 ) {
       id = "";
      } else {
       id = this.contractPaymentMethodId;
      }

      if(!this.contractPaymentMethodId){
        this.error = 'Por favor selecione uma forma de pagamento';
        this.$emit('input', {...this.cpm, error: this.error});
        return;
      }

      if(id == 'newPayment'){
        this.error = 'Selecione uma forma de pagamento';
        this.$emit('input', {...this.cpm, error: this.error});
      } else if (id == 'CC'){
         let success;
         if (this.cpm.paymentMethodId) {
           try {
             success = await this.$validator.validateAll();
           } catch(err) {

             this.error = 'Por favor Verifique os dados do cartão';
           }
         } else {
           this.error = 'Por favor selecione uma bandeira.';
         }


         this.$emit('input', {...this.cpm, error: this.error});

      } else if(id=='BC') {
        this.$emit('input', {paymentMethod:{paymentMethodId: 12}});

      } else if(id=='PX') {
        if(this.pix){
          this.$emit('input', {...this.pix, error: this.error});
        }else{
          this.$emit('input', {paymentMethod:{paymentMethodId: 120}});
        }
      }else if(id=='109') {
        this.$emit('input', {paymentMethod:{paymentMethodId: 109}});

      }else if(id=="senff") {

        this.$emit('input', {paymentMethod:{paymentMethodId: 21}});
      } else if(id=="newBalance"){

        if(this.saldoCorrente < this.totalComDesconto){
          this.error='Saldo insuficiente';
        }
        this.$emit('input', {paymentMethod:{paymentMethodId: 109}, error: this.error});
      } else {
        if(this.paymentSelected && this.paymentSelected.number) {
          if(!this.secureCodeCreditCard || this.secureCodeCreditCard.length < 3) {
            this.error = 'Verifique o cvv';
          }
          this.paymentSelected.cvv = this.secureCodeCreditCard;
        } else if (this.paymentSelected.paymentMethod.paymentShortName == 'DC') {
            this.error = undefined;
        } else {
          this.error = 'Favor selecionar uma forma de pagamento';
        }
        this.$emit('input', {...this.paymentSelected, error: this.error});

       }
    },
    usarSaldo(){
      if(this.statusContrato != 1 || !this.contractId || this.salesType != "ADHESIONVEHICLEADDITIONAL")
        return false;
      if(this.planId == 21 || this.planId == 22 || this.planId == 31 || this.planId == 32){
        return true;
      }else
        return false;
    },

  Redirecionar() {
    this.$refs.summary.validateAll().then(r => {
      let promise = Sales.adhesion(this.request).then(r => {
        this.code = r.status.code;
        this.pixUrl = r.boletoUrl;
        $('body').stop().animate({
          scrollTop: 0
        }, '500', 'swing');
      }).catch(err => {
        this.msgError = err.data.status.message;
        this.code = err.data.status.code;
        $('body').stop().animate({
          scrollTop: 0
        }, '500', 'swing');
      });

      this.$store.dispatch('loading', promise);

    });

  },



    handleCC(){
      if(this.contractPaymentMethodId == 'BC'){
        return
      }

      switch(this.cpm.paymentMethodId){
      case "6":
          this.cpm.paymentMethodId = 6;
          this.cpm.paymentMethod.paymentMethodId = 6;
          this.cpm.brand = "Visa";
          this.cpm.caption="Visa";
          this.cpm.paymentMethod.imagePath="visa2.svg";
          break;
      case "7":
          this.cpm.paymentMethodId = 7;
          this.cpm.paymentMethod.paymentMethodId = 7;
          this.cpm.brand = "Mastercard";
          this.cpm.caption="Mastercard";
          this.cpm.paymentMethod.imagePath="mastercard2.svg";
          break;
      case "8":
          this.cpm.paymentMethodId = 8;
          this.cpm.paymentMethod.paymentMethodId = 8;
          this.cpm.brand = "American Express";
          this.cpm.caption="American Express";
          this.cpm.paymentMethod.imagePath="amex.svg";
          break;
      case "10":
          this.cpm.paymentMethodId = 10;
          this.cpm.paymentMethod.paymentMethodId = 10;
          this.cpm.brand = "Elo";
          this.cpm.caption="Elo";
          this.cpm.paymentMethod.imagePath="elo2.svg";
          break;
      case "11":
          this.cpm.paymentMethodId = 11;
          this.cpm.paymentMethod.paymentMethodId = 11;
          this.cpm.brand = "HiperCard";
          this.cpm.caption="HiperCard";
          this.cpm.paymentMethod.imagePath="hipercard2.svg";
          break;
      case "22":
        this.cpm.paymentMethodId = 22;
        this.cpm.paymentMethod.paymentMethodId = 22;
        this.cpm.brand = "Senff";
        this.cpm.caption="Senff";
        this.cpm.paymentMethod.imagePath="senff.svg";
          break;
        }

        if (!this.cpm.number && !this.cpm.ownerName && !this.cpm.expirationMonth && !this.cpm.expirationYear && !this.cpm.cvv) {
          this.error = 'Por favor verifique os dados do cartão.';
          this.$emit('input', {...this.cpm, error: this.error});
        }
      },
    getShortNameByPaymentMethodId(paymentMethodId) {
      const mapping = {
        6: 'CC',   // Visa
        7: 'CC',   // Mastercard
        8: 'CC',   // American Express
        10: 'CC',  // Elo
        11: 'CC',  // HiperCard
        12: 'BC',  // Boleto
        21: 'SF',  // Senff
        22: 'SF',  // Senff Virtual
        109: 'CR', // Conta Corrente/Saldo
        120: 'PX'  // PIX
      };

      return mapping[paymentMethodId] || null;
    },

    getShortNameByPaymentShortName(paymentShortName) {
      return paymentShortName || null;
    },

    isPaymentMethodAuthorized(shortName) {
      if (!this.taxIdNumber) {
        return true;
      }

      if (!this.paymentMethodsAuthorized || Object.keys(this.paymentMethodsAuthorized).length === 0) {
        return true;
      }

      if (!this.paymentMethodsAuthorized.hasOwnProperty(shortName)) {
        return true;
      }

      return this.paymentMethodsAuthorized[shortName] === true;
    },

    hasAnyPaymentMethodAvailable() {
      if (!this.taxIdNumber) {
        return this.hasAnyPaymentMethodInPlan();
      }

      if (!this.paymentMethodsAuthorized || Object.keys(this.paymentMethodsAuthorized).length === 0) {
        return this.hasAnyPaymentMethodInPlan();
      }

      const methodChecks = {
        'DC': () => this.isPaymentMethodAuthorized('DC') && this.typesAlowed.bankAccount,
        'CC': () => this.isPaymentMethodAuthorized('CC') && this.typesAlowed.creditCard,
        'BC': () => this.isPaymentMethodAuthorized('BC') && this.typesAlowed.bankBill,
        'PX': () => this.isPaymentMethodAuthorized('PX') && this.hasPixInPlan(),
        'CR': () => this.isPaymentMethodAuthorized('CR') && this.hasContaCorrenteInPlan(),
        'DO': () => this.isPaymentMethodAuthorized('DO') && this.typesAlowed.doc,
        'TE': () => this.isPaymentMethodAuthorized('TE') && this.typesAlowed.ted
      };

      return Object.values(methodChecks).some(check => check());
    },

    hasAnyPaymentMethodInPlan() {
      if (!this.typesAlowed || Object.keys(this.typesAlowed).length === 0) {
        return true;
      }

      return this.typesAlowed.bankAccount ||
             this.typesAlowed.creditCard ||
             this.typesAlowed.bankBill ||
             this.typesAlowed.doc ||
             this.typesAlowed.ted ||
             this.hasPixInPlan() ||
             this.hasContaCorrenteInPlan();
    },

    hasPixInPlan() {
      if (!this.metodosDePagamento || !this.metodosDePagamento.length) {
        return false;
      }
      return this.metodosDePagamento.some(pm => pm.paymentMethodId === 120);
    },

    hasContaCorrenteInPlan() {
      return this.planId == 28 || (this.contaCorrente !== undefined);
    }
  },

  components:{
    PaymentOptions,
    successPage
  },
}



// WEBPACK FOOTER //
// ./src/pages/common/payment/payment.js